<button class="go-back" (click)="location.back()" mat-raised-button>
  <mat-icon mat-list-icon>keyboard_backspace</mat-icon> Zurück
</button>

<mat-card *ngIf="customerData && customerData.customer">
  <h2 class="mat-title">{{customerData.customer.name}}</h2>

  <mat-card-content>
    <table class="mat-table data-table">
      <tr>
        <th>Kundenummer</th>
        <td>{{customerData.customer.external_id}}</td>
      </tr>
      <tr>
        <th>Registrierungsdatum</th>
        <td>{{customerData.customer.entry | date:'short'}}</td>
      </tr>
    </table>

    <ng-container *ngIf="customerForm">
      <form class="user-form" [formGroup]="customerForm">
        <mat-grid-list cols="6" rowHeight="100px">
          <mat-grid-tile colspan="3">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label id="customer-name">Name</mat-label>
              <input aria-labelledby="customer-name" type="text" matInput formControlName="name">
            </mat-form-field>
          </mat-grid-tile>

        </mat-grid-list>

        <div>
          <button (click)="saveCustomer()" mat-raised-button color="accent">Speichern
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </form>
    </ng-container>

  </mat-card-content>
</mat-card>

<mat-card *ngIf="customerData?.customer">
  <h2 class="mat-title">Zugänge</h2>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab *ngFor="let scope of customerData.scopedClaims2customer; let k = index" label="{{scope.desc}}">
        <ng-template matTabContent [formGroup]="c2cForm">

          <sta-tab-content [customerData]="customerData" [c2cForm]="c2cForm" [scope]="scope"></sta-tab-content>

        </ng-template>
      </mat-tab>

      <mat-tab label="Neu">
        <ng-template matTabContent>
          <mat-accordion [formGroup]="c2cForm">
            <mat-card-content>
              <app-claim-edit [c2cForm]="c2cForm" [customerData]="customerData" [expansionPanel]="null" [c2c]="null" [c2cFormGroup]="null"></app-claim-edit>
            </mat-card-content>
          </mat-accordion>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="customerData?.customer">
  <h2 class="mat-title">Zugänge für Mitarbeiter</h2>
  <div class="actions">
    <button (click)="addCustomer2Domain()" mat-raised-button color="accent">Hinzufügen
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <mat-card-content *ngIf="customerData.customer.customerDomains">
    <mat-accordion [formGroup]="c2cForm">

      <mat-expansion-panel *ngFor="let d of customerData.customer.customerDomains; let i = index">

          <mat-expansion-panel-header>
            <mat-panel-title>
              {{getClaimDesc(d.claimName)}}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-card-content>
            <app-domain-edit [domain]="d" [domainFormGroup]="getDomainForm(d)" (domainRemove)="removeCustomer2Domain($event)"></app-domain-edit>
          </mat-card-content>

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
